import clsx from 'clsx';
import {Spin} from 'antd';
import styles from './Loader.module.scss';

interface LoaderProps {
  mode?: 'normal' | 'reverse-color';
}

export const Loader = ({mode}: LoaderProps) => {
  return (
    <div className={clsx(styles.wrapper, mode)}>
      <Spin />
    </div>
  );
};
